import I from '../types.ts';

const showAnnounce: I['showAnnounce'] = function (id) {
    this.setState({ announceId: id, currentPage: 'announce' });
};

export default showAnnounce;
